import {
  GET_CERTAIN_CATEGORY_PAPER_NUMBER,
  GET_RECIPIENT_AND_SENDERS,
  ADD_PAPER,
  ADD_PAPER_ERROR,
  RESET_PAPER_STORE,
  CATEGORY_VALUE_0,
  GET_CERTAIN_PAGE_PAPERS,
  GET_ALL_PAGE_PAPERS,
  ALL_PAPERS_NUMBER,
  CURRENT_YEAR_PAPERS_NUMBER,
  GET_NOT_ARCHIVED_PAGE_PAPERS,
  NOT_ARCHIVED_PAPERS_NUMBER,
  GET_CERTAIN_PAPER,
  GET_CERTAIN_PAPER_ERROR,
  UPDATE_CERTAIN_PAPER,
  UPDATE_CERTAIN_PAPER_ERROR,
} from "../types";

import { AddPaperProps } from "../../types/actions/papers";

import * as api from "../../api/axiosBase";

export const getCertainCategoryPaperNumber = (id: any) => async (dispatch) => {
  try {
    const { data } = await api.getCertainCategoryPaperNumber(id);
    dispatch({
      type: GET_CERTAIN_CATEGORY_PAPER_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {
    //dispatch({ type: LOGIN, payload: error.response.data.status });
    // dispatch({ type: LOGIN_ERROR, payload: error.response.data.message });
  }
};

export const getRecipientAndSenders = () => async (dispatch) => {
  try {
    const { data } = await api.getRecipientAndSenders();
    dispatch({
      type: GET_RECIPIENT_AND_SENDERS,
      payload: data.data.recipientsSenders,
    });
  } catch (error) {}
};

export const addPaper = (formData: AddPaperProps) => async (dispatch) => {
  try {
    const { data } = await api.addPaper(formData);
    dispatch({ type: ADD_PAPER, payload: data.status });
    dispatch({ type: ADD_PAPER_ERROR, payload: "" });
  } catch (error) {
    dispatch({
      type: ADD_PAPER_ERROR,
      payload: error.response.data.message,
    });
    dispatch({ type: ADD_PAPER, payload: error.response.data.status });
  }
};

export const resetPaperStore = () => async (dispatch) => {
  dispatch({ type: RESET_PAPER_STORE });
};

export const setCertainCategoryValueTo0 = () => async (dispatch) => {
  dispatch({ type: CATEGORY_VALUE_0 });
};

export const getCertainPagePapers =
  (page: number, limit: number, query: string) => async (dispatch) => {
    try {
      const { data } = await api.getCertainPagePapers(page, limit, query);
      dispatch({
        type: GET_CERTAIN_PAGE_PAPERS,
        payload: data.data.data,
      });
    } catch (error) {}
  };

export const getAllPagePapers =
  (page: any, limit: any, query: string) => async (dispatch) => {
    try {
      const { data } = await api.getAllPagePapers(page, limit, query);
      dispatch({
        type: GET_ALL_PAGE_PAPERS,
        payload: data.data.data,
      });
    } catch (error) {}
  };

export const allPapersNumber = () => async (dispatch) => {
  try {
    const { data } = await api.allPapersNumber();
    dispatch({
      type: ALL_PAPERS_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {}
};

export const currentYearPapersNumber = (query: string) => async (dispatch) => {
  try {
    const { data } = await api.currentYearPapersNumber(query);
    dispatch({
      type: CURRENT_YEAR_PAPERS_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {}
};

// get not archived page papers
export const getNotArchivedPagePapers =
  (page: number, limit: number) => async (dispatch) => {
    try {
      const { data } = await api.getNotArchivedPagePapers(page, limit);
      dispatch({
        type: GET_NOT_ARCHIVED_PAGE_PAPERS,
        payload: data.data.data,
      });
    } catch (error) {}
  };
// get not archived page papers
/*export const getNotArchivedPagePapers = () => async (dispatch) => {
  try {
    const { data } = await api.getNotArchivedPagePapers();
    dispatch({
      type: GET_NOT_ARCHIVED_PAGE_PAPERS,
      payload: data.data.data
    })
  } catch (error) {
  }
};*/

// Get archived papers number
export const notArchivedPapersNumber = (query: string) => async (dispatch) => {
  try {
    const { data } = await api.notArchivedPapersNumber(query);
    dispatch({
      type: NOT_ARCHIVED_PAPERS_NUMBER,
      payload: data.data.data,
    });
  } catch (error) {}
};

// get certain Paper
export const getCertainPaper = (id: string, history) => async (dispatch) => {
  try {
    const { data } = await api.getCertainPaper(id);
    dispatch({
      type: GET_CERTAIN_PAPER,
      payload: data.data.data,
    });
    history.push("/edit-paper");
  } catch (error) {
    dispatch({
      type: GET_CERTAIN_PAPER_ERROR,
      payload: error.response.data.message,
    });
  }
};

// update certain user
export const updateCertainPaper =
  (formData: any, id, history) => async (dispatch) => {
    console.log(formData);
    try {
      const { data } = await api.updateCertainPaper(formData, id);
      dispatch({ type: UPDATE_CERTAIN_PAPER, payload: data });
      dispatch(getCertainPaper(id, history));
    } catch (error) {
      dispatch({
        type: UPDATE_CERTAIN_PAPER_ERROR,
        payload: error.response.data,
      });
    }
  };
